require('turbolinks').start()

import 'controllers/public'
